import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";

import authReducer from "./auth/authSlice";
import activeReducer from "./active/activeSlice";
import userReducer from "./users/usersSlice";
import whatsappLoginReducer from "./whatsappLogin/whatsappLoginSlice";
import propertyCategoryReducer from "./propertyCategory/propertyCategorySlice";
import selectPropertyCategoryReducer from './selectPropertyCategory/selectPropertyCategorySlice';
import propertySubCategoryReducer from "./propertySubCategory/propertySubCategorySlice";
import selectPropertySubCategoryReducer from './selectPropertySubCategory/selectPropertySubCategorySlice';
import locationManagementReducer from "./locationManagement/locationManagementSlice";
import advertisePackageReducer from "./advertisePackage/advertisePackageSlice";
import propertyFeatureReducer from "./propertyFeature/propertyFeatureSlice";
import PropertyFacilityReducer from "./propertyFacility/propertyFacilitySlice"
import advertiseReducer from './advertise/advertiseSlice';
import selectAdvertisePackageReducer from './selectAdvertisePackage/selectAdvertisePackageSlice';
import changeAdvertiseStatusReducer from './changeAdvertiseStatus/changeAdvertiseStatusSlice';
import changeUserProfileStatusReducer from './changeUserProfileStatus/changeUserProfileStatusSlice';
import settingsReducer from './settings/settingsSlice';
import contactFormReducer from './contactForm/contactFormSlice';
import propertyFacilityReducer from "./propertyFacility/propertyFacilitySlice";
import selectLocationManagementReducer from './selectLocationManagement/selectLocationManagementSlice';
import pushNotificationManagementReducer from './pushNotificationManagement/pushNotificationManagementSlice';
import dashboardReportReducer from './dashboardReport/dashboardReportSlice';
import dashboardUserReducer from './dashboardUser/dashboardUserSlice';
import dashboardAdvertiseReducer from './dashboardAdvertise/dashboardAdvertiseSlice';
import paymentReducer from './payment/paymentSlice';
import selectAdvertiseReducer from './selectAdvertise/selectAdvertiseSlice';
import advertiseExportReducer from './advertiseExport/advertiseExportSlice';
import selectPossessionTypeReducer from './selectPossessionType/selectPossessionTypeSlice';
import selectUserReducer from './selectUser/selectUserSlice';
import selectPropertyFacilityReducer from './selectPropertyFacility/selectPropertyFacilitySlice';
import selectPropertyFeatureReducer from './selectPropertyFeature/selectPropertyFeatureSlice';
import paymentExportReducer from './paymentExport/paymentExportSlice';
import changeAdvertiseMediaPositionReducer from './changeAdvertiseMediaPosition/changeAdvertiseMediaPositionSlice';
import companyOtpLoginReducer from './companyOtpLogin/companyOtpLoginSlice';
import agentManagementReducer from './agentManagement/agentManagementSlice';
import agentTransferLogsReducer from './agentTransferLogs/agentTransferLogsSlice';

const reducers = {
  auth: authReducer,
  active: activeReducer,
  whatsappLogin: whatsappLoginReducer,
  companyOtpLogin: companyOtpLoginReducer,
  user: userReducer,
  propertyCategory: propertyCategoryReducer,
  propertySubCategory: propertySubCategoryReducer,
  selectPropertyCategory: selectPropertyCategoryReducer,
  selectPropertySubCategory: selectPropertySubCategoryReducer,
  locationManagement: locationManagementReducer,
  advertisePackage: advertisePackageReducer,
  propertyFeature: propertyFeatureReducer,
  PropertyFacility: PropertyFacilityReducer,
  advertise: advertiseReducer,
  selectAdvertisePackage: selectAdvertisePackageReducer,
  changeAdvertiseStatus: changeAdvertiseStatusReducer,
  changeUserProfileStatus: changeUserProfileStatusReducer,
  settings: settingsReducer,
  contactForm: contactFormReducer,
  propertyFacility: propertyFacilityReducer,
  selectLocationManagement: selectLocationManagementReducer,
  pushNotificationManagement: pushNotificationManagementReducer,
  dashboardReport: dashboardReportReducer,
  dashboardUser: dashboardUserReducer,
  dashboardAdvertise: dashboardAdvertiseReducer,
  payment: paymentReducer,
  selectAdvertise: selectAdvertiseReducer,
  advertiseExport: advertiseExportReducer,
  selectPossessionType: selectPossessionTypeReducer,
  selectUser: selectUserReducer,
  selectPropertyFacility: selectPropertyFacilityReducer,
  selectPropertyFeature: selectPropertyFeatureReducer,
  paymentExport: paymentExportReducer,
  changeAdvertiseMediaPosition: changeAdvertiseMediaPositionReducer,
  agentManagement: agentManagementReducer,
  agentTransferLogs: agentTransferLogsReducer,
};

export const rootReducer = combineReducers(reducers);

const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined | any,
  action: AnyAction
) => {
  if (action.type === "auth/logoutUser/fulfilled") {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
  // devTools: false
});

export default store;

// Define type for hooks
type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export hooks
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
